// @flow
import { type ActionType, createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import { applyPenders } from 'lib/common';
import * as DepositAPI from 'lib/api/deposit';

const GET_DEPOSIT_BALANCE = 'deposit/GET_DEPOSIT_BALANCE';
const GET_DEPOSIT_HISTORY = 'deposit/GET_DEPOSIT_HISTORY';

const getDepositBalance = createAction(GET_DEPOSIT_BALANCE, DepositAPI.getDepositBalance);
const getDepositHistory = createAction(GET_DEPOSIT_HISTORY, DepositAPI.getDepositHistory);

export interface DepositActionCreators {
  getDepositBalance(): any;
  getDepositHistory(params: any): any;
}

export const actionCreators: DepositActionCreators = {
  getDepositBalance,
  getDepositHistory,
};

export type DepositState = {
  balance: number,
  depositId: ?string,
  history: Array<any>,
  historyCount: number,
};

const initialState: DepositState = {
  balance: 0,
  depositId: null,
  history: [],
  historyCount: 0,
};

const reducer = handleActions({}, initialState);

export default applyPenders(reducer, [
  {
    type: GET_DEPOSIT_BALANCE,
    onSuccess: (state: DepositState, action: any) => {
      return produce(state, (draft) => {
        draft.balance = action.payload.data.balance;
        draft.depositId = action.payload.data.depositId;
      });
    },
  },
  {
    type: GET_DEPOSIT_HISTORY,
    onSuccess: (state: DepositState, action: any) => {
      return produce(state, (draft) => {
        draft.history = action.payload.data.data;
        draft.historyCount = action.payload.data.count;
      });
    },
  },
]);



// WEBPACK FOOTER //
// ./src/store/modules/deposit.js